import { divIcon, DivIcon } from 'leaflet'
import { renderToStaticMarkup } from 'react-dom/server'
import React from 'react'
import { brandMarkers, markerFills, pinOptions } from './constants'
import { ReactComponent as StatusPin } from '../../../../../assets/src/lib/markers/kanban/statusPin.svg'

interface GetBrandMarkerProps {
  brand: keyof typeof brandMarkers | null
  status: keyof typeof markerFills
}
export const getBrandMarker = ({
  brand, status,
}: GetBrandMarkerProps): DivIcon => {
  const Marker = brand ? brandMarkers[brand] : StatusPin
  const fill = markerFills[status]

  return divIcon({
    ...pinOptions,
    html: renderToStaticMarkup(
      <Marker
        fill={fill}
        height={44}
        width={29.15}
      />,
    ),
  })
}
